<template>
    <div></div>
</template>

<script>
export default {
    created() {
        this.$api.logout(() => {
            window.location.replace('/');
        });
    },
};
</script>

<style scoped>

</style>
